module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-responsive-table-box"
  }, [(_vm.hasRecords()) ? _c('div', [_c('table', {
    class: _vm.tableCssClasses
  }, [_c('thead', [_c('tr', [(_vm.selectable) ? _c('th', [_c('ui-checkbox', {
    nativeOn: {
      "change": function($event) {
        _vm.selectAll($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.fields), function(item) {
    return _c('th', {
      class: _vm.getThClass(item)
    }, [_vm._v(_vm._s(item.label))])
  }), _vm._v(" "), (_vm.actions) ? _c('th') : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.records), function(row, index) {
    return _c("ui-grid-row", {
      ref: "row",
      refInFor: true,
      tag: "tr",
      attrs: {
        "data-id": row.id
      }
    }, [_c('td', [_c('ui-checkbox', {
      attrs: {
        "name": "checkbox-item"
      },
      nativeOn: {
        "change": function($event) {
          _vm.updateSelecteds($event)
        }
      }
    })], 1), _vm._v(" "), _vm._l((_vm.itemsRow(row)), function(value, field) {
      return _c('td', {
        class: _vm.getTdClass()
      }, [_vm._v(_vm._s(_vm.getRowValue(field, value)))])
    }), _vm._v(" "), (_vm.actions) ? _c('td', {
      staticClass: "td-actions"
    }, _vm._l((_vm.actions), function(item) {
      return _c('ui-button', {
        attrs: {
          "icon": item.icon,
          "type": "button",
          "primary": item.primary,
          "raised": item.raised,
          "fab": "",
          "colored": ""
        },
        nativeOn: {
          "click": function($event) {
            item.handleClick(row)
          }
        }
      })
    })) : _vm._e()], 2)
  }))]), _vm._v(" "), (_vm.selectable) ? _c('div', [_c('hr'), _vm._v(" "), _c('ui-button', {
    attrs: {
      "primary": "",
      "raised": "",
      "colored": "",
      "disabled": !_vm.hasRowSelected
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeSelecteds($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedsLabel))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.hasRecords()) ? _c('ui-spinner', {
    attrs: {
      "center": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.paging.pages) ? _c('pagination', {
    attrs: {
      "for": _vm.name,
      "per-page": _vm.paging.limit,
      "records": _vm.paging.total,
      "chunk": 10,
      "count-text": "Mostrando {from} a {to} de {count} registros|{count} registros|Um registro"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-150ecc84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiGrid.vue
// module id = 263
// module chunks = 2